import React from 'react';
import FormGroupPart from './FormGroupPart';
import messages from '../registrationMessages';
import classNames from 'classnames';
import { displayHoursAsDaysAndTime, getTimeAbbr } from '@/shared/utils/absenceFormat';

const AbsenceBalanceFormGroup = ({
  absenceBalance,
  durationType,
  intl,
  durationDays,
  duration,
  showValidation,
}) => {
  if (!absenceBalance) return null;

  const { balance, hoursInDay, balanceDays, maxDays, maxMinutes } = absenceBalance;
  const abbr = getTimeAbbr(intl, messages);

  // Always compute in hours so displayHoursAsDaysAndTime gets the right input
  const balanceAfterHours =
    durationType === 0
      ? balance - (duration ?? 0) / 60
      : balance - (durationDays ?? 0) * hoursInDay;
  const balanceAfter = durationType === 0 ? balanceAfterHours : balanceDays - (durationDays ?? 0);

  return (
    <div className="form-group">
      <FormGroupPart label={messages.AbsenceBalance}>
        {durationType === 0 ? (
          <p className="form-control-static">
            {(balance ?? 0).toTime()}
            &nbsp;
            <span>{intl.formatMessage(messages.Hours)}</span>
          </p>
        ) : (
          <p className="form-control-static">
            {displayHoursAsDaysAndTime(balance ?? 0, hoursInDay, abbr)}
          </p>
        )}
      </FormGroupPart>
      <FormGroupPart label={messages.BalanceAfter} invalid={showValidation && balanceAfter < 0}>
        <p className={classNames('form-control-static', { errorMsg: balanceAfter < 0 })}>
          {durationType === 0 ? (
            (balanceAfterHours ?? 0).toTime()
          ) : (
            displayHoursAsDaysAndTime(balanceAfterHours ?? 0, hoursInDay, abbr)
          )}
          &nbsp;
          <span>{intl.formatMessage(durationType === 0 ? messages.Hours : messages.Days)}</span>
        </p>
      </FormGroupPart>
    </div>
  );
};
export default AbsenceBalanceFormGroup;
